/**
 * Returns true if the given date is a Hanuman day (Tuesday or Saturday).
 * Uses the device's local timezone.
 */
export default function isHanumanDay(date = new Date()) {
  const d = date.getDay();
  return d === 2 || d === 6;
}
